import React from "react";
import { useState } from "react";
import { works } from "../lib/allProject";
import AllWorks from "./AllWorks";
import Modal from "react-modal";
import WorkCard from "./smallComponentes/WorkCard";
import WorkModal from "./smallComponentes/Modal";

Modal.setAppElement("body");
const customStylesProjects = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#0f172a",
  },
  overLay: {},
};
function Work() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [worksIsOpen, setWorksIsOpen] = useState(false);
  const [workdata, setWorkData] = useState("");

  function openModal(link) {
    setWorkData(link);
    setModalIsOpen(true);
  }

  const closeProjects = () => {
    setWorksIsOpen(false);
  };

  const openProject = () => {
    setWorksIsOpen(true);
  };

  return (
    <section
      id="work"
      name="work"
      className="w-full text-gray-300 md:h-screen bg-[#0f172a]"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="ph-8">
          <p className="inline text-4xl font-bold text-gray-300 border-b-4 border-violet-600">
            Work
          </p>
          <p className="py-6">//Check out some of my recent work</p>
        </div>
        {/* Container */}
        <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
          {/* Grid Item */}

          {works.slice(0, 6).map((work, key) => (
            <WorkCard work={work} key={key} openModal={openModal} />
          ))}
        </div>
        {/* <div className="flex justify-center">
          <a to="work">
            <button
              className="flex items-center px-6 py-3 text-white border-2 mt-14 group bg-violet-600 border-violet-600 hover:bg-violet-700"
              onClick={openProject}
            >
              View All Work
            </button>
          </a>
        </div> */}

        <Modal
          isOpen={worksIsOpen}
          onRequestClose={closeProjects}
          style={customStylesProjects}
          contentLabel="Example Modal"
          closeTimeoutMS={300}
        >
          <AllWorks closeProjects={closeProjects} />
        </Modal>
      </div>

      <WorkModal
        setModalIsOpen={setModalIsOpen}
        modalIsOpen={modalIsOpen}
        workdata={workdata}
      />
    </section>
  );
}

export default Work;
